<h1 class="subheading">Confirm discard changes?</h1>
<mat-dialog-content>Your changes have not been saved. Discard changes?</mat-dialog-content>
<mat-dialog-actions class="pull-right mt-4">
  <button mat-stroked-button class="primary mr-4" mat-dialog-close>Cancel</button>
  <button mat-flat-button class="primary" [mat-dialog-close]="true" tabindex="0">OK</button>
</mat-dialog-actions>
